import Fundraise from './container';

export default Fundraise;
